import React from "react";
import { Pressable, Text, View } from "react-native";
import MaterialIcons from "react-native-vector-icons/MaterialIcons";
import { useTheme } from "../../../theme";
import styles from "../SubmitTicketScreenStyles";
import mobileStyles from "../SubmitTicketScreen.mobile.style";

type Props = {
  onBackPress: () => void;
  mobile?: boolean;
};

const SubmitTicketHeader: React.FC<Props> = ({ onBackPress, mobile }) => {
  const { colors, resolvedTheme } = useTheme();
  const isDark = resolvedTheme === "dark";

  if (mobile) {
    return (
      <View style={[mobileStyles.headerBlock, isDark && { backgroundColor: colors.background.surface, borderBottomWidth: 1, borderBottomColor: colors.border.divider }]}>
        <View style={mobileStyles.breadcrumbRow}>
          <Pressable
            accessibilityRole="button"
            onPress={onBackPress}
            style={mobileStyles.backArrowWrap}
          >
            <MaterialIcons name="arrow-back" size={22} color={isDark ? colors.text.primary : "#1a2332"} />
          </Pressable>
          <Text style={[mobileStyles.title, isDark && { color: colors.text.primary }]}>Submit Ticket</Text>
        </View>
        <Text style={[mobileStyles.subtitle, isDark && { color: colors.text.secondary }]}>
          All fields marked with * are required
        </Text>
      </View>
    );
  }

  return (
    <View style={[styles.headerBlock, isDark && { backgroundColor: "transparent" }]}>
      <View style={styles.breadcrumbRow}>
        <Pressable
          accessibilityRole="button"
          onPress={onBackPress}
          style={({ hovered, pressed }) => [
            styles.breadcrumbLink,
            hovered ? styles.breadcrumbLinkHover : null,
            pressed ? styles.breadcrumbLinkPressed : null,
          ]}
        >
          <Text style={[styles.breadcrumbLinkText, isDark && { color: colors.brand?.primary ?? "#3D8BFF" }]}>Ticketing Portal</Text>
        </Pressable>
        <Text style={[styles.breadcrumbSeparator, isDark && { color: colors.text.secondary }]}>/</Text>
        <Text style={[styles.breadcrumbCurrent, isDark && { color: colors.text.secondary }]}>Submit Ticket</Text>
      </View>
      <Text style={[styles.title, isDark && { color: colors.text.primary }]}>Submit a Support Ticket</Text>
      <Text style={[styles.subtitle, isDark && { color: colors.text.secondary }]}>
        Describe the issue. The Sustain Team will triage within minutes.
      </Text>
    </View>
  );
};

export default SubmitTicketHeader;
